import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IStudyTools } from "src/app/models/studytools/studytools";
import { lastValueFrom } from 'rxjs';
import { Helpers } from '../helpers';

@Injectable({ providedIn: 'root' })
export class ToolsService {
  private TOOLS_SERVICE_URL = environment.toolService.url + environment.toolService.apiVersion;
  constructor(private http: HttpClient) {
  }

  getGridData(sponsor: string, portalId: number, featureName: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<IStudyTools[]>(this.TOOLS_SERVICE_URL + `Tools/${featureName}/${sponsor}/${portalId}`, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  openDocument(sponsor: string, portalId: number, mid: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.TOOLS_SERVICE_URL + `Tools/Download/${sponsor}/${portalId}/${mid}`, {}))
        .then(
          (response?: any) => {
            if (response.Success) {
              let splitArray: any[] = response.Data.FileName.split('.');
              let fileType: string = splitArray[splitArray.length - 1];
              if (fileType.toLowerCase() == 'pdf') {
                lastValueFrom(this.http.get(response.Data.FileSaSUri, { responseType: 'blob' })).then((data: any) => {
                  var blob = new Blob([data], { type: 'application/pdf' });
                  var url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.href = url;
                  anchor.target = '_blank';
                  anchor.rel = "noreferrer";
                  var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                  });
                  anchor.dispatchEvent(clickEvent);
                }).finally(() => {
                  resolve(response);
                });
              } else {
                window.open(response.Data.FileSaSUri, '_blank', 'noreferrer');
                resolve(response);
              }
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  openDocumentLink(sponsor: string, portalId: number, aliasName: string, namedDestination: string = "") {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.TOOLS_SERVICE_URL + `Tools/OpenDocument/${sponsor}/${portalId}/${aliasName}`, {}))
        .then(
          (response?: any) => {
            if (response.Success) {
              let splitArray: any[] = response.Data.FileName.split('.');
              let fileType: string = splitArray[splitArray.length - 1];
              
              if (fileType.toLowerCase() == 'pdf') {
                lastValueFrom(this.http.get(response.Data.FileSaSUri, { responseType: 'blob' })).then((data: any) => {
                  var blob = new Blob([data], { type: 'application/pdf' });
                  var url = window.URL.createObjectURL(blob);

                  if (!Helpers.isNullOrUndefined(namedDestination) || namedDestination != "")
                    url = url + namedDestination;

                  var anchor = document.createElement('a');
                  anchor.href = url;
                  anchor.target = '_self';
                  var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                  });
                  anchor.dispatchEvent(clickEvent);
                }).finally(() => {
                  resolve(response);
                });
              } else {
                window.open(response.Data.FileSaSUri, '_self', '');
                resolve(response);
              }
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
